import Msd from "@/modules/msd/common/service/Msd";

const url = {
    create    : "/api/site?customer={0}",
    recent    : "/api/site/recents",
    siteById  : "/api/site/{0}",
    unitById  : "/api/site/search/{0}",
    components: "/api/site/{0}/component",
    contracts : "/api/site/{0}/contract",
    contacts  : "/api/site/{0}/contact",
    recipients: "/api/site/{0}/recipients",
    increcipients: "/api/recipient",
    recipient: "/api/recipient/{0}",
    update: {
        customer: "/api/site/{0}?customer={1}",
        core: "/api/site/{0}/core",
        spec: "/api/site/{0}/spec",
        note: "/api/site/{0}/note",
        dms : "/api/site/{0}/dms",
        type: "/api/site/{0}/type/{1}",
        bulk: "/api/site/bulkupdate"
    },

    condition: {
        history: "/api/site/{0}/tzb/history",
        current: "/api/site/{0}/tzb",
        byId   : "/api/site/{0}/tzb/{1}"
    },

};

const maintype = {
    evevator : 1,
    escalator: 2
};

const status = {
    active    : 1,
    outOfOrder: 2,
    shutDown  : 3
};

const RECIPIENT = {
    USAGE: Object.freeze({INCIDENT: "INCIDENT", COSTS: "COSTS", REPAIR: "REPAIR" }),
    TYPE : Object.freeze({INVOICE: "INVOICE", BENEFIT: "BENEFIT", FORWARD: "FORWARD"}),
}

const CONTRACT = {
    LIM: 1,
    DLS: 2,
    MNT: 3,
    EMC: 4,
    ZUS: 5
}

import moment from "moment";
import Core from "@/modules/core/service/Core";
import SearchRequest from "@/modules/core/service/private/SearchRequest";
import Contract from "@/modules/msd/unit/service/private/Contract";

export default {
    RECIPIENT: {
        USAGE: RECIPIENT.USAGE,
        TYPE : RECIPIENT.TYPE,
    },
    CONTRACT: CONTRACT,
    goto (component, siteId) {
        const filter = {
            field: "incidentSiteIdQuery",
            value: siteId
        };

        Core.nav.push(component, "incidents", filter);
    },

    isActive (site) {
        return site.status && site.status.id === status.active;
    },

    isElevator (site) {
        return site.type.groupId === maintype.evevator;
    },

    isEscalator (site) {
        return site.type.groupId === maintype.escalator;
    },

    isLiftmanagement (unit) {
        // noinspection JSUnresolvedVariable
        return !!unit.contractLimId
    },

    isInLftmanagement (site) {
        if (!site.liftmanagement) {
            return false;
        }

        const contract = site.liftmanagement.contract;
        if (!contract.unit || !contract.unit.end) {
            return false;
        }

        const today = moment ();
        const expiration = moment (contract.unit.end);
        return today <= expiration;
    },

    statusColor (site) {
        if (!this.isActive(site)) {
            if (!this.site.liftmanagement || !this.site.liftmanagement.contract || !this.site.liftmanagement.contract.type) {
                return "red";
            }
        }

        return this.isInLftmanagement(site) ? "green" : "white";
    },

    statusColorUnit (site) {
        if (!this.isActive(site)) {
            return "red";
        }

        return "green";
    },

    components (siteId, success) {
        return Core.method.get(url.components, siteId).then(data => success(data));
    },

    recents () {
        return Core.method.get(url.recent);
    },

    sites (filter, success) {
        return Core.method.post (Msd.url.sitesearch, filter).then(data => success (data));
    },

    unit (unitId) {
        return Core.method.get(url.unitById, unitId);
    },

    sitesByContact (contactId, success) {
        return Core.method.get (Msd.url.sitecontactsearch, contactId).then(data => success (data));
    },

    site (siteId, success) {
        return Core.method.get(url.siteById, siteId).then(data => success(data));
    },

    create (customerId) {
        return Core.method.post(url.create, {
            id           : null,
            inspectionId : null,
            fabricNo     : "Neu",
            country      : "DE",
            zip          : "---",
            city         : "---",
            street       : "---"
        }, customerId);
    },

    recipients (unitIds, usage, success) {
        Core.method.put(url.increcipients, {
            units: unitIds,
            usage: usage
        }).then(data => success(data));
    },

    recipient (recipientId, success) {
        Core.method.get(url.recipient, recipientId).then(data => success(data));
    },

    search (customerId, value, full, filter) {
        const body = {
            start: 0,
            length: 15,
            sort: {
                column: "fabricNo",
                dir   : "ASC"
            },
            filter: {
                customer: [ customerId ],
                onlyMyCustomers   : !(filter && filter.onlyMyCustomers === false),
                field             : full ? "siteMatchAllQuery" : "siteFabricNoQuery",
                value             : value,
                onlyLiftmanagement: !(filter && filter.onlyLiftmanagement === false)
            }
        };

        return Core.method.post(SearchRequest.url("/site"), body).then ((data) => {
            return data.data;
        });
    },

    contracts (siteId, success) {
        return Core.method.get(url.contracts, siteId).then(data => success(data));
    },

    contacts (siteId, success) {
        return Core.method.get(url.contacts, siteId).then(data => success(data));
    },

    storeRecipients (siteId, recipients, success) {
        return Core.method.putVoid(url.recipients, recipients, siteId).then(() => success ());
    },

    condition: {
        history (unit) {
            return Core.method.get(url.condition.history, unit.id)
        },

        load (unit, id) {
            return Core.method.get(url.condition.byId, unit.id, id);
        },

        loadCurrent (unit) {
            return Core.method.get(url.condition.current, unit.id);
        },

        report (component, reportId, conditionId, reportName) {
            Core.transfer.load("/api/site/report/" + reportId + "/" + conditionId, ((blob) => {
                const link = document.createElement("a");
                link.href =blob;
                link.download = reportName;
                link.click();
            }), () => {
            });
        },

        save (unitId, id, tzb) {
            return Core.method.put(url.condition.byId, tzb, unitId, id);
        }
    },


    update: {
        customer (unitId, customerId) {
            return Core.method.put(url.update.customer, null, unitId, customerId);
        },

        core (siteId, data, success) {
            return Core.method.put(url.update.core, data, siteId).then((data) => success (data));
        },

        spec (siteId, data) {
            return Core.method.put(url.update.spec, data, siteId);
        },

        note (siteId, data, success) {
            return Core.method.put(url.update.note, data, siteId).then((data) => success (data));
        },

        dms (siteId, data, success, error) {
            return Core.method.put(url.update.dms, data, siteId).then ((data) => success (data)).catch((e) => error(e));
        },

        type (unitId, typeId) {
            return Core.method.put(url.update.type, null, unitId, typeId);
        },

        bulk (units, customer) {
            const unitIds = units.map (unit => unit.id);
            return Core.method.putVoid(url.update.bulk, {
                unitIds: unitIds,
                customerId: customer.id
            });
        }
    },

    contract: Contract,

    filter: {
        unit (filter, unit) {
            if (filter.active && unit.status && unit.status.id === 1) {
                return true;
            }

            if (filter.inactive && unit.status && unit.status.id !== 1) {
                return true;
            }

            if (filter.orphan && !this.isLiftmanagement(unit)) {
                return true;
            }

            return false;
        },
    }
}